import { render, staticRenderFns } from "./similarityTableRow.vue?vue&type=template&id=bd89e240&scoped=true"
import script from "./similarityTableRow.vue?vue&type=script&lang=js"
export * from "./similarityTableRow.vue?vue&type=script&lang=js"
import style0 from "./similarityTableRow.vue?vue&type=style&index=0&id=bd89e240&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd89e240",
  null
  
)

export default component.exports